import { FC, useMemo } from 'react'

import { FieldLabel } from 'partner360/components/fieldLabel/FieldLabel'

import { getAmplifyTrackFieldLabelTranslation } from './helpers/getAmplifyTrackFieldLabelTranslation'

import styles from './AmplifyTrack.module.scss'

interface IAmplifyTrackProps {
  isRetail?: boolean
  isDistributor?: boolean
  isGlobalPartner?: boolean
  isPowerElite?: boolean
  isPowerEliteGlobal?: boolean
  amplifyTrackValue: string
}

export const AmplifyTrack: FC<IAmplifyTrackProps> = ({
  amplifyTrackValue,
  isPowerElite,
  isPowerEliteGlobal,
  isDistributor,
  isRetail,
  isGlobalPartner,
}) => {
  const labelTranslation = useMemo(
    () =>
      getAmplifyTrackFieldLabelTranslation({
        isRetail,
        isDistributor,
        isGlobalPartner,
      }),
    [isDistributor, isRetail, isGlobalPartner]
  )

  return (
    <div className={styles.root}>
      <FieldLabel labelTranslation={labelTranslation} />
      <div className={styles.mainContainer}>
        <div className={styles.amplifyTrack}>{amplifyTrackValue}</div>
        {isPowerEliteGlobal ? (
          <div className={styles.elite}>Elite Global</div>
        ) : (
          isPowerElite && <div className={styles.elite}>Elite</div>
        )}
      </div>
    </div>
  )
}
